import { useNavigate } from 'react-router-dom';
import { ContentContainer } from '@/components/shell/ContentContainer';
import { STRINGS } from '@/strings/strings';

/**
 * D-11 Bestellung-abgebrochen — `/checkout/cancel`.
 *
 * Stripe redirects here via STRIPE_CHECKOUT_CANCEL_URL when the user
 * clicks "Zurück" on Stripe Checkout or closes the Checkout page
 * without completing payment. Single-state page — no polling, no
 * async, no entitlement fetch needed (the user wasn't charged; PWA
 * state is unchanged).
 *
 * Briefing K-11 D-11 verbatim copy. Two CTAs:
 *   - Primary "Zurück zur Übersicht"  → /            (home)
 *   - Secondary "Erneut versuchen"     → /account/subscription (A-02)
 *
 * No state-discrimination, no auth-state branches: the same UI for
 * trial users + active subscribers + pack-only buyers + lifecycle-
 * phase users. Stripe-cancel is a uniform UX moment — "cancelled,
 * not charged, here's your next step."
 */
export function CheckoutCancelRoute() {
  const navigate = useNavigate();
  const S = STRINGS.checkout.cancel;

  return (
    <div className="min-h-screen bg-dream-white">
      <ContentContainer>
        <div
          className="flex min-h-screen flex-col items-center justify-center gap-4 py-10 desktop:mx-auto desktop:max-w-[640px]"
          data-testid="checkout-cancel"
        >
          <h1 className="text-center text-xl font-semibold leading-7 text-dream-navy">
            {S.heading}
          </h1>
          <p className="max-w-md text-center text-sm leading-relaxed text-dream-navy">{S.body}</p>
          <button
            type="button"
            onClick={() => navigate('/')}
            className="mt-2 flex w-full max-w-xs items-center justify-center overflow-hidden rounded-lg bg-dream-gold px-4 py-[14px] text-xs font-semibold leading-3 text-dream-navy transition-colors hover:bg-dream-gold/90"
            data-testid="checkout-cancel-primary-cta"
          >
            {S.primaryCta}
          </button>
          <button
            type="button"
            onClick={() => navigate('/account/subscription')}
            className="text-xs font-medium text-dream-navy/60 underline decoration-solid"
            data-testid="checkout-cancel-secondary-cta"
          >
            {S.secondaryCta}
          </button>
        </div>
      </ContentContainer>
    </div>
  );
}
